import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _descriptor2, _RouteScrollManager_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { next, schedule } from "@ember/runloop";
import Service, { service } from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { isTesting } from "discourse-common/config/environment";
import { bind } from "discourse-common/utils/decorators";
const STORE_KEY = Symbol("scroll-location");

/**
 * This service is responsible for managing scroll position when transitioning.
 * When visiting a new route, this service will scroll to the top of the page.
 * When returning to a previously-visited route via the browser back button,
 * this service will scroll to the previous scroll position.
 *
 * To opt-out of the behaviour, individual routes can add a scrollOnTransition
 * boolean to their RouteInfo metadata using Ember's `buildRouteInfoMetadata` hook.
 */
let RouteScrollManager = disableImplicitInjections(_class = (_class2 = (_RouteScrollManager_brand = /*#__PURE__*/new WeakSet(), class RouteScrollManager extends Service {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _RouteScrollManager_brand);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "historyStore", _descriptor2, this);
    _defineProperty(this, "scrollElement", isTesting() ? document.getElementById("ember-testing-container") : document.scrollingElement);
  }
  routeWillChange() {
    this.historyStore.set(STORE_KEY, [this.scrollElement.scrollLeft, this.scrollElement.scrollTop]);
  }
  routeDidChange(transition) {
    if (transition.isAborted) {
      return;
    }
    if (!_assertClassBrand(_RouteScrollManager_brand, this, _shouldScroll).call(this, transition.to)) {
      return;
    }
    const scrollLocation = this.historyStore.get(STORE_KEY) || [0, 0];
    next(() => schedule("afterRender", () => this.scrollElement.scrollTo(...scrollLocation)));
  }
  init() {
    super.init(...arguments);
    this.router.on("routeDidChange", this.routeDidChange);
    this.router.on("routeWillChange", this.routeWillChange);
  }
  willDestroy() {
    this.router.off("routeDidChange", this.routeDidChange);
    this.router.off("routeWillChange", this.routeWillChange);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "historyStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "routeWillChange", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "routeWillChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "routeDidChange", [bind], Object.getOwnPropertyDescriptor(_class2.prototype, "routeDidChange"), _class2.prototype)), _class2)) || _class;
function _shouldScroll(routeInfo) {
  // Leafmost route has priority
  for (let route = routeInfo; route; route = route.parent) {
    const scrollOnTransition = route.metadata?.scrollOnTransition;
    if (typeof scrollOnTransition === "boolean") {
      return scrollOnTransition;
    }
  }

  // No overrides - default to true
  return true;
}
export { RouteScrollManager as default };